/* eslint-disable react/prop-types */
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ConfirmationModal from "../Modal";

export const useModalSimple = () => {
  const [showSignModal, setSignModalVisibility] = React.useState(false);

  const onCloseSignModal = () => {
    setSignModalVisibility(false);
  };

  const onShowSignModal = () => {
    setSignModalVisibility(true);
  };

  return { showSignModal, onCloseSignModal, onShowSignModal };
};

export const ModalSimple = ({ showSignModal, onCloseSignModal }) => {
  const history = useHistory();
  return (
    <ConfirmationModal
      open={showSignModal}
      onClose={onCloseSignModal}
      onAccept={() => {
        history.push("/compra/firma-simple");
      }}
      bodyContent="Es requerido que el solicitante tenga su cédula vigente para obtener un certificado digital."
    />
  );
};
